import { createReducer, on } from '@ngrx/store';

import * as fromPersistedStateActions from '../actions/persisted-state.actions';
import * as fromSettingActions from '../actions/setting.actions';

export const officeFeatureKey = 'office';

export interface State {
  calculatorsEnabled: boolean;
  contactCardEnabled: boolean;
  contactCardPhotoUrl: string | null;
  documentLinksEnabled: boolean;
  name: string | null;
  netSheetsEnabled: boolean;
  orderTitleEmail: string | null;
  orderTitleEnabled: boolean;
  purchasePhoneAndEmailEnabled: boolean;
  schoolDistrictInfo: boolean;
  walkingFarmEnabled: boolean;
}

export const initialState: State = {
  calculatorsEnabled: false,
  contactCardEnabled: false,
  contactCardPhotoUrl: null,
  documentLinksEnabled: false,
  name: null,
  netSheetsEnabled: false,
  orderTitleEmail: null,
  orderTitleEnabled: false,
  purchasePhoneAndEmailEnabled: false,
  schoolDistrictInfo: false,
  walkingFarmEnabled: false
};

export const reducer = createReducer(
  initialState,
  on(
    fromSettingActions.updateReferralCodeSuccess,
    fromSettingActions.loadSettingsSuccess,
    fromSettingActions.refreshReferralCodeSuccess,
    fromPersistedStateActions.migratePersistedOldStateReferralCodeSuccess,
    (state, { payload }) => ({
      ...state,
      calculatorsEnabled: payload.data.office.calculatorsEnabled,
      contactCardEnabled: !payload.data.hideContactCard,
      contactCardPhotoUrl: payload.data.office.contactCardImageUrl,
      documentLinksEnabled: payload.data.office.showDocumentLinks,
      name: payload.data.office.name,
      netSheetsEnabled: payload.data.office.netSheetEnabled,
      orderTitleEmail: payload.data.office.orderTitleEmail,
      orderTitleEnabled: /^(.+)@(.+).(.+)$/i.test(payload.data.office.orderTitleEmail),
      purchasePhoneAndEmailEnabled: payload.data.office.phoneAndEmailPurchase,
      schoolDistrictInfo: payload.data.office.schoolDistrictInfo,
      walkingFarmEnabled: payload.data.office.walkingFarmEnabled
    })
  ),
  on(fromPersistedStateActions.loadPersistedStateFailure, fromPersistedStateActions.persistedStateReset, () => ({
    ...initialState
  })),
  on(fromPersistedStateActions.loadPersistedStateSuccess, (state, { payload }) => ({
    ...state,
    ...payload[officeFeatureKey]
  }))
);
